<template>
	<div class="goods-info-body">
		<div class="title-box">
			<div class="title0"></div>
			<div class="title1 title">
				商品名称
			</div>
			<div class="title0 title">
				属性
			</div>
			<div class="title0 title">
				单价
			</div>
			<div class="title0 title">
				退货数量
			</div>
			<div class="title0 title">
				小计
			</div>

		</div>
		<div class="row-box" v-for="item in goodData" :key='item.goodsId'>
			<div class="row row0">
				<img v-if="item.imgurl === ''" src="~/images/img/no-goods-img.png">
				<w-image v-else :src="item.imgurl"></w-image>
			</div>
			<div class="row row1">
				<el-tooltip class="item" effect="dark" placement="top">
					<div slot="content">{{item.pname}}</div>
					<div class="name-box">{{item.pname}}</div>
				</el-tooltip>
			</div>
			<div class="row row0">
				{{item.spec}}
			</div>
			<div class="row row0">
				￥{{$fxUtils.toFixedSHW(item.price, 2)}}
			</div>
			<div class="row row0">
				x{{item.itemquantity}}
			</div>
			<div class="row row0" style="position: relative;">
				<span>￥{{$fxUtils.toFixedSHW(item.refundmoney, 2)}}</span>
			</div>
		</div>
		<div class="total">
			<div class="summary">
				<div><span>应退金额：</span>￥{{$fxUtils.toFixedSHW(total, 2)}} <i v-if="orderstatusName === '退货完成' && autoflag" @click="openDetailDialog">明细</i></div>
				<div><span>已退金额：</span>￥{{orderstatusName === '退货完成'?$fxUtils.toFixedSHW(total, 2):'0.00'}}</div>
				<div><span>未退金额：</span>￥{{orderstatusName === '退货完成'?'0.00':$fxUtils.toFixedSHW(total, 2)}} <i @click="reload">刷新</i></div>
			</div>
		</div>
		<el-dialog title="明细" class="confirm-dialog" top='60px' @close="cancelDetailDialog" :visible.sync="detailDialogFlag" width='1025px' :close-on-click-modal="false">
			<el-table
				:data="tableData"
				:header-cell-style="{background:'#F7F8FA', color:'#333333', fontSize:'14px', fontWeight:'bold'}">
				<el-table-column
					width="200px"
					prop="orderChildOrdernumber"
					label="子退单号"
					align="center">
				</el-table-column>
				<el-table-column
					width="120px"
					prop="orderChildSourcetype"
					label="子退单来源"
					align="center">
					<template slot-scope='scope'>
						<span v-if="scope.row.orderChildSourcetype === 0">待付款</span>
						<span v-if="scope.row.orderChildSourcetype === 1">待接单</span>
						<span v-if="scope.row.orderChildSourcetype === 2">待发货</span>
						<span v-if="scope.row.orderChildSourcetype === 3">待收货</span>
						<span v-if="scope.row.orderChildSourcetype === 4">已完成</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="money"
					width="120px"
					label="退款金额"
					align="center">
					<template slot-scope='scope'>
						<span>{{$fxUtils.toFixedSHW(scope.row.money, 2)}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="childNegativeOrderNumber"
					label="抵消子订单号"
					align="center">
					<template slot-scope='scope'>
						<div v-for='(item,index) in scope.row.detailList' :key='index'>
							<span v-if="item.paymode === 5" style="margin-right: 5px;color:var(--fx-primary-color);text-decoration: underline;cursor: pointer;" @click="btnClick(item.serialnumber)">{{item.serialnumber}}</span>
							<span v-if="item.paymode !== 5" style="margin-right: 5px;">{{item.serialnumber}}</span>
							<span v-if="item.paymode === 0">线下</span>
							<span v-if="item.paymode === 2">微信</span>
							<span v-if="item.paymode === 5">抵消</span>
							<span style="margin-left: 5px;">￥{{$fxUtils.toFixedSHW(item.money, 2)}}</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'goodsInfo',
	props: {
		goodData: Array,
		deliveryData: Object,
		autoflag: Boolean,
		orderstatusName: String
	},
	data () {
		return {
			orderChildNumber: '',
			tabParams: {},
			orderParams: {},
			tableData: [],
			detailDialogFlag: false,
			isMore: false,
			punit: null,
			number: null,
			total: null
		}
	},
	watch: {
		goodData: {
			handler (val) {
				let a = val
				this.number = 0
				this.total = a[0].finalprice
				if (a.length === 1) {
					this.isMore = false
					for (let i = 0; i < a.length; i++) {
						this.number = this.number + a[i].itemquantity
						this.punit = a[i].punit
					}
				} else {
					this.isMore = true
					for (let i = 0; i < a.length; i++) {
						this.number = this.number + a[i].itemquantity
						this.punit = a[i].punit
					}
				}
			}
		}
	},
	methods: {
		btnClick (num) {
			this.orderParams = {}
			this.tabParams = {}
			this.tabParams.organid = this.organid
			this.tabParams.isSellerpull = this.deliveryData.isSellerpull
			this.tabParams.sellerShopId = this.deliveryData.sellerShopId
			this.tabParams.orderStatus = +this.deliveryData.billState
			this.orderParams.buypullstate = this.deliveryData.buypullstate
			this.orderParams.differ = this.deliveryData.differ
			this.orderParams.orderId = this.deliveryData.orderId
			this.orderParams.statusId = this.deliveryData.statusId
			switch (this.deliveryData.billState) {
			case '0':
				this.tabParams.active = '待付款'
				this.orderParams.billState = '待付款'
				break
			case '1':
				this.tabParams.active = '待付款'
				this.orderParams.billState = '待付款'
				break
			case '2':
				if (this.deliveryData.isSellerpull) {
					this.tabParams.active = '备货中'
					this.orderParams.billState = '备货中'
				} else {
					this.tabParams.active = '待付款'
					this.orderParams.billState = '待付款'
				}
				break
			case '3':
				this.tabParams.active = '待收货'
				this.orderParams.billState = '待收货'
				break
			case '4':
				this.tabParams.active = '已完成'
				this.orderParams.billState = '已完成'
				break
			case '5':
				this.tabParams.active = '已取消'
				this.orderParams.billState = '已取消'
				break
			}
			if (this.tabParams.orderStatus === 0) {
				this.statusCode = '07_0001_0001_00'
			} else if (this.tabParams.orderStatus === 1) {
				this.statusCode = '07_0001_0004_00'
			} else if (this.tabParams.orderStatus === 2) {
				if (this.tabParams.isSellerpull === true) {
					this.statusCode = '07_0001_0010_00'
				} else {
					this.statusCode = '07_0001_0007_00'
				}
			} else if (this.tabParams.orderStatus === 3) {
				this.statusCode = '07_0001_0013_00'
			} else if (this.tabParams.orderStatus === 4) {
				this.statusCode = '07_0001_0016_00'
			} else if (this.tabParams.orderStatus === 5) {
				this.statusCode = '07_0001_0019_00'
			}
			this.getAuthority(this.statusCode, num)
		},
		getAuthority (val, num) {
			let params = {
				pId: '07_0001_0000_00'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					this.flag = false
					for (let i = 0; i < a.length; i++) {
						if (a[i] === val) {
							console.log(a[i])
							this.flag = true
						}
					}
					if (this.flag) {
						window.sessionStorage.setItem('tabInfo', JSON.stringify(this.tabParams))
						window.sessionStorage.setItem('orderInfo', JSON.stringify(this.orderParams))
						window.sessionStorage.setItem('orderChildNumber', num)
						this.$fxEventBus.$emit('setMenu', '6-1')
						this.$router.push('/dock/orderDetail')
					} else {
						this.$message.error('没有订单权限，不能进入订单详情界面')
					}
				}
			})
		},
		reload () {
			let params = {
				refundId: this.deliveryData.refundid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/payback/refresh`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$parent.getInfo()
					this.$message.success('钱款已经退回您的银行卡，如未到账，您可以再次点击帮助退款！')
				}
			})
		},
		openDetailDialog () {
			let params = {
				refundId: this.deliveryData.refundid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/orderchildlist`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data
					this.detailDialogFlag = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancelDetailDialog () {
			this.detailDialogFlag = false
		}
	}
}
</script>

<style lang="stylus" scoped>
.goods-info-body {
	margin-top :10px;
	font-size: 14px
	.title-box{
		display :flex;
		flex-direction :row;
		height :40px;
		background-color :#F7F8FA;
		align-items: center
		.title{
			display :flex;
		}
		.title0{
			flex :2;
			box-sizing :border-box;
			padding :0px 10px;
		}
		.title1{
			flex :4;
			box-sizing :border-box;
			padding :0px 10px;
		}
	}
	.row-box{
		display :flex;
		flex-direction :row;
		overflow-x :hidden;
		align-items: center;
		.row{
			height :80px;
			display :flex;
			align-items :center;
			justify-content :flex-start;
			border-bottom :1px solid #EDEFFC;
			img{
				width :60px;
				height :60px;
				margin:0 auto;
			}
		}
		.row0{
			box-sizing :border-box;
			flex:2;
			padding :0px 10px;
		}
		.row1{
			box-sizing :border-box;
			flex:4;
			padding :0px 10px;
		}
		.name-box{
			width :100%;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			max-height :40px;
			line-height :20px;
			text-align: left;
		}
	}
	.total{
		display flex;
		justify-content flex-end;
	}
	.summary {
		color: #333333
		font-size: 14px
		-webkit-box-orient: vertical
		flex-direction: column
		-webkit-box-pack: end
		-ms-flex-pack: end
		margin: 20px 0
		text-align: left
		line-height: 32px
		span {
			display: inline-block
			width: 90px
			text-align: right
			padding-right: 10px;
		}
		i {
			color: var(--fx-primary-color)
			text-decoration: underline
			cursor: pointer
			padding-left: 11px
		}
	}
}
</style>
<style lang="stylus">
.confirm-dialog{
	.el-dialog__header{
		text-align :left
	}
	.el-dialog__body{
		padding : 10px 10px 20px 10px;
	}
}
</style>
